import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    apiPostCoupon: function (token, codes, shop) {
        var pointCode = (Array.isArray(codes)) ? codes.join(",") : codes;
        var params = {
            'codes[]': pointCode,
            shop: shop
        };
        var url = this.config().bzbsModuleUrl + '/coupon/process';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },
    apiGetSKU: function (token, codes) {
        var params = {
            'codes[]': codes
        };
        var url = this.config().bzbsModuleUrl + '/coupon/validate';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    }
}
